const pokemon = [
    {
        "name": "Choose your pokemon",
        "url": "/assets/shiny/meme.jpg"
    },
    {
        "name": "Rowlet",
        "url": "/assets/shiny/rowlet.png"
    },
    {
        "name": "Dartrix",
        "url": "/assets/shiny/dartrix.png"
    },
    {
        "name": "Decidueye",
        "url": "/assets/shiny/decidueye-hisuian.png"
    },
    {
        "name": "Cyndaquil",
        "url": "/assets/shiny/cyndaquil.png"
    },
    {
        "name": "Quilava",
        "url": "/assets/shiny/quilava.png"
    },
    {
        "name": "Typhlosion",
        "url": "/assets/shiny/typhlosion-hisuian.png"
    },
    {
        "name": "Oshawott",
        "url": "/assets/shiny/oshawott.png"
    },
    {
        "name": "Dewott",
        "url": "/assets/shiny/dewott.png"
    },
    {
        "name": "Samurott",
        "url": "/assets/shiny/samurott-hisuian.png"
    },
    {
        "name": "Bidoof",
        "url": "/assets/shiny/bidoof.png"
    },
    {
        "name": "Bibarel",
        "url": "/assets/shiny/bibarel.png"
    },
    {
        "name": "Starly",
        "url": "/assets/shiny/starly.png"
    },
    {
        "name": "Staravia",
        "url": "/assets/shiny/staravia.png"
    },
    {
        "name": "Staraptor",
        "url": "/assets/shiny/staraptor.png"
    },
    {
        "name": "Shinx",
        "url": "/assets/shiny/shinx.png"
    },
    {
        "name": "Luxio",
        "url": "/assets/shiny/luxio.png"
    },
    {
        "name": "Luxray",
        "url": "/assets/shiny/luxray.png"
    },
    {
        "name": "Wurmple",
        "url": "/assets/shiny/wurmple.png"
    },
    {
        "name": "Silcoon",
        "url": "/assets/shiny/silcoon.png"
    },
    {
        "name": "Beautifly",
        "url": "/assets/shiny/beautifly.png"
    },
    {
        "name": "Cascoon",
        "url": "/assets/shiny/cascoon.png"
    },
    {
        "name": "Dustox",
        "url": "/assets/shiny/dustox.png"
    },
    {
        "name": "Ponyta",
        "url": "/assets/shiny/ponyta.png"
    },
    {
        "name": "Rapidash",
        "url": "/assets/shiny/rapidash.png"
    },
    {
        "name": "Eevee",
        "url": "/assets/shiny/eevee.png"
    },
    {
        "name": "Vaporeon",
        "url": "/assets/shiny/vaporeon.png"
    },
    {
        "name": "Jolteon",
        "url": "/assets/shiny/jolteon.png"
    },
    {
        "name": "Flareon",
        "url": "/assets/shiny/flareon.png"
    },
    {
        "name": "Espeon",
        "url": "/assets/shiny/espeon.png"
    },
    {
        "name": "Umbreon",
        "url": "/assets/shiny/umbreon.png"
    },
    {
        "name": "Leafeon",
        "url": "/assets/shiny/leafeon.png"
    },
    {
        "name": "Glaceon",
        "url": "/assets/shiny/glaceon.png"
    },
    {
        "name": "Sylveon",
        "url": "/assets/shiny/sylveon.png"
    },
    {
        "name": "Zubat",
        "url": "/assets/shiny/zubat.png"
    },
    {
        "name": "Golbat",
        "url": "/assets/shiny/golbat.png"
    },
    {
        "name": "Crobat",
        "url": "/assets/shiny/crobat.png"
    },
    {
        "name": "Drifloon",
        "url": "/assets/shiny/drifloon.png"
    },
    {
        "name": "Drifblim",
        "url": "/assets/shiny/drifblim.png"
    },
    {
        "name": "Kricketot",
        "url": "/assets/shiny/kricketot.png"
    },
    {
        "name": "Kricketune",
        "url": "/assets/shiny/kricketune.png"
    },
    {
        "name": "Buizel",
        "url": "/assets/shiny/buizel.png"
    },
    {
        "name": "Floatzel",
        "url": "/assets/shiny/floatzel.png"
    },
    {
        "name": "Burmy",
        "url": "/assets/shiny/burmy.png"
    },
    {
        "name": "Wormadam",
        "url": "/assets/shiny/wormadam.png"
    },
    {
        "name": "Mothim",
        "url": "/assets/shiny/mothim.png"
    },
    {
        "name": "Geodude",
        "url": "/assets/shiny/geodude.png"
    },
    {
        "name": "Graveler",
        "url": "/assets/shiny/graveler.png"
    },
    {
        "name": "Golem",
        "url": "/assets/shiny/golem.png"
    },
    {
        "name": "Stantler",
        "url": "/assets/shiny/stantler.png"
    },
    {
        "name": "Wyrdeer",
        "url": "/assets/shiny/wyrdeer.png"
    },
    {
        "name": "Munchlax",
        "url": "/assets/shiny/munchlax.png"
    },
    {
        "name": "Snorlax",
        "url": "/assets/shiny/snorlax.png"
    },
    {
        "name": "Paras",
        "url": "/assets/shiny/paras.png"
    },
    {
        "name": "Parasect",
        "url": "/assets/shiny/parasect.png"
    },
    {
        "name": "Pichu",
        "url": "/assets/shiny/pichu.png"
    },
    {
        "name": "Pikachu",
        "url": "/assets/shiny/pikachu.png"
    },
    {
        "name": "Raichu",
        "url": "/assets/shiny/raichu.png"
    },
    {
        "name": "Abra",
        "url": "/assets/shiny/abra.png"
    },
    {
        "name": "Kadabra",
        "url": "/assets/shiny/kadabra.png"
    },
    {
        "name": "Alakazam",
        "url": "/assets/shiny/alakazam.png"
    },
    {
        "name": "Chimchar",
        "url": "/assets/shiny/chimchar.png"
    },
    {
        "name": "Monferno",
        "url": "/assets/shiny/monferno.png"
    },
    {
        "name": "Infernape",
        "url": "/assets/shiny/infernape.png"
    },
    {
        "name": "Buneary",
        "url": "/assets/shiny/buneary.png"
    },
    {
        "name": "Lopunny",
        "url": "/assets/shiny/lopunny.png"
    },
    {
        "name": "Cherubi",
        "url": "/assets/shiny/cherubi.png"
    },
    {
        "name": "Cherrim",
        "url": "/assets/shiny/cherrim.png"
    },
    {
        "name": "Psyduck",
        "url": "/assets/shiny/psyduck.png"
    },
    {
        "name": "Golduck",
        "url": "/assets/shiny/golduck.png"
    },
    {
        "name": "Combee",
        "url": "/assets/shiny/combee.png"
    },
    {
        "name": "Vespiquen",
        "url": "/assets/shiny/vespiquen.png"
    },
    {
        "name": "Scyther",
        "url": "/assets/shiny/scyther.png"
    },
    {
        "name": "Scizor",
        "url": "/assets/shiny/scizor.png"
    },
    {
        "name": "Kleavor",
        "url": "/assets/shiny/kleavor.png"
    },
    {
        "name": "Heracross",
        "url": "/assets/shiny/heracross.png"
    },
    {
        "name": "Mime Jr.",
        "url": "/assets/shiny/mime-jr.png"
    },
    {
        "name": "Mr. Mime",
        "url": "/assets/shiny/mr-mime.png"
    },
    {
        "name": "Aipom",
        "url": "/assets/shiny/aipom.png"
    },
    {
        "name": "Ambipom",
        "url": "/assets/shiny/ambipom.png"
    },
    {
        "name": "Magikarp",
        "url": "/assets/shiny/magikarp.png"
    },
    {
        "name": "Gyarados",
        "url": "/assets/shiny/gyarados.png"
    },
    {
        "name": "Shellos",
        "url": "/assets/shiny/shellos.png"
    },
    {
        "name": "Gastrodon",
        "url": "/assets/shiny/gastrodon.png"
    },
    {
        "name": "Qwilfish",
        "url": "/assets/shiny/qwilfish-hisuian.png"
    },
    {
        "name": "Overqwil",
        "url": "/assets/shiny/overqwil.png"
    },
    {
        "name": "Happiny",
        "url": "/assets/shiny/happiny.png"
    },
    {
        "name": "Chansey",
        "url": "/assets/shiny/chansey.png"
    },
    {
        "name": "Blissey",
        "url": "/assets/shiny/blissey.png"
    },
    {
        "name": "Budew",
        "url": "/assets/shiny/budew.png"
    },
    {
        "name": "Roselia",
        "url": "/assets/shiny/roselia.png"
    },
    {
        "name": "Roserade",
        "url": "/assets/shiny/roserade.png"
    },
    {
        "name": "Carnivine",
        "url": "/assets/shiny/carnivine.png"
    },
    {
        "name": "Petilil",
        "url": "/assets/shiny/petilil.png"
    },
    {
        "name": "Lilligant",
        "url": "/assets/shiny/lilligant-hisuian.png"
    },
    {
        "name": "Tangela",
        "url": "/assets/shiny/tangela.png"
    },
    {
        "name": "Tangrowth",
        "url": "/assets/shiny/tangrowth.png"
    },
    {
        "name": "Barboach",
        "url": "/assets/shiny/barboach.png"
    },
    {
        "name": "Whiscash",
        "url": "/assets/shiny/whiscash.png"
    },
    {
        "name": "Croagunk",
        "url": "/assets/shiny/croagunk.png"
    },
    {
        "name": "Toxicroak",
        "url": "/assets/shiny/toxicroak.png"
    },
    {
        "name": "Ralts",
        "url": "/assets/shiny/ralts.png"
    },
    {
        "name": "Kirlia",
        "url": "/assets/shiny/kirlia.png"
    },
    {
        "name": "Gardevoir",
        "url": "/assets/shiny/gardevoir.png"
    },
    {
        "name": "Gallade",
        "url": "/assets/shiny/gallade.png"
    },
    {
        "name": "Yanma",
        "url": "/assets/shiny/yanma.png"
    },
    {
        "name": "Yanmega",
        "url": "/assets/shiny/yanmega.png"
    },
    {
        "name": "Hippopotas",
        "url": "/assets/shiny/hippopotas.png"
    },
    {
        "name": "Hippowdon",
        "url": "/assets/shiny/hippowdon.png"
    },
    {
        "name": "Pachirisu",
        "url": "/assets/shiny/pachirisu.png"
    },
    {
        "name": "Stunky",
        "url": "/assets/shiny/stunky.png"
    },
    {
        "name": "Skuntank",
        "url": "/assets/shiny/skuntank.png"
    },
    {
        "name": "Teddiursa",
        "url": "/assets/shiny/teddiursa.png"
    },
    {
        "name": "Ursaring",
        "url": "/assets/shiny/ursaring.png"
    },
    {
        "name": "Ursaluna",
        "url": "/assets/shiny/ursaluna.png"
    },
    {
        "name": "Goomy",
        "url": "/assets/shiny/goomy.png"
    },
    {
        "name": "Sliggoo",
        "url": "/assets/shiny/sliggoo-hisuian.png"
    },
    {
        "name": "Goodra",
        "url": "/assets/shiny/goodra-hisuian.png"
    },
    {
        "name": "Onix",
        "url": "/assets/shiny/onix.png"
    },
    {
        "name": "Steelix",
        "url": "/assets/shiny/steelix.png"
    },
    {
        "name": "Rhyhorn",
        "url": "/assets/shiny/rhyhorn.png"
    },
    {
        "name": "Rhydon",
        "url": "/assets/shiny/rhydon.png"
    },
    {
        "name": "Rhyperior",
        "url": "/assets/shiny/rhyperior.png"
    },
    {
        "name": "Bonsly",
        "url": "/assets/shiny/bonsly.png"
    },
    {
        "name": "Sudowoodo",
        "url": "/assets/shiny/sudowoodo.png"
    },
    {
        "name": "Lickitung",
        "url": "/assets/shiny/lickitung.png"
    },
    {
        "name": "Lickilicky",
        "url": "/assets/shiny/lickilicky.png"
    },
    {
        "name": "Togepi",
        "url": "/assets/shiny/togepi.png"
    },
    {
        "name": "Togetic",
        "url": "/assets/shiny/togetic.png"
    },
    {
        "name": "Togekiss",
        "url": "/assets/shiny/togekiss.png"
    },
    {
        "name": "Turtwig",
        "url": "/assets/shiny/turtwig.png"
    },
    {
        "name": "Grotle",
        "url": "/assets/shiny/grotle.png"
    },
    {
        "name": "Torterra",
        "url": "/assets/shiny/torterra.png"
    },
    {
        "name": "Porygon",
        "url": "/assets/shiny/porygon.png"
    },
    {
        "name": "Porygon2",
        "url": "/assets/shiny/porygon2.png"
    },
    {
        "name": "Porygon-Z",
        "url": "/assets/shiny/porygon-z.png"
    },
    {
        "name": "Gastly",
        "url": "/assets/shiny/gastly.png"
    },
    {
        "name": "Haunter",
        "url": "/assets/shiny/haunter.png"
    },
    {
        "name": "Gengar",
        "url": "/assets/shiny/gengar.png"
    },
    {
        "name": "Spiritomb",
        "url": "/assets/shiny/spiritomb.png"
    },
    {
        "name": "Murkrow",
        "url": "/assets/shiny/murkrow.png"
    },
    {
        "name": "Honchkrow",
        "url": "/assets/shiny/honchkrow.png"
    },
    {
        "name": "Unown",
        "url": "/assets/shiny/unown.png"
    },
    {
        "name": "Spheal",
        "url": "/assets/shiny/spheal.png"
    },
    {
        "name": "Sealeo",
        "url": "/assets/shiny/sealeo.png"
    },
    {
        "name": "Walrein",
        "url": "/assets/shiny/walrein.png"
    },
    {
        "name": "Remoraid",
        "url": "/assets/shiny/remoraid.png"
    },
    {
        "name": "Octillery",
        "url": "/assets/shiny/octillery.png"
    },
    {
        "name": "Skorupi",
        "url": "/assets/shiny/skorupi.png"
    },
    {
        "name": "Drapion",
        "url": "/assets/shiny/drapion.png"
    },
    {
        "name": "Growlithe",
        "url": "/assets/shiny/growlithe-hisuian.png"
    },
    {
        "name": "Arcanine",
        "url": "/assets/shiny/arcanine-hisuian.png"
    },
    {
        "name": "Glameow",
        "url": "/assets/shiny/glameow.png"
    },
    {
        "name": "Purugly",
        "url": "/assets/shiny/purugly.png"
    },
    {
        "name": "Machop",
        "url": "/assets/shiny/machop.png"
    },
    {
        "name": "Machoke",
        "url": "/assets/shiny/machoke.png"
    },
    {
        "name": "Machamp",
        "url": "/assets/shiny/machamp.png"
    },
    {
        "name": "Chatot",
        "url": "/assets/shiny/chatot.png"
    },
    {
        "name": "Duskull",
        "url": "/assets/shiny/duskull.png"
    },
    {
        "name": "Dusclops",
        "url": "/assets/shiny/dusclops.png"
    },
    {
        "name": "Dusknoir",
        "url": "/assets/shiny/dusknoir.png"
    },
    {
        "name": "Piplup",
        "url": "/assets/shiny/piplup.png"
    },
    {
        "name": "Prinplup",
        "url": "/assets/shiny/prinplup.png"
    },
    {
        "name": "Empoleon",
        "url": "/assets/shiny/empoleon.png"
    },
    {
        "name": "Mantyke",
        "url": "/assets/shiny/mantyke.png"
    },
    {
        "name": "Mantine",
        "url": "/assets/shiny/mantine.png"
    },
    {
        "name": "Basculin",
        "url": "/assets/shiny/basculin.png"
    },
    {
        "name": "Basculegion",
        "url": "/assets/shiny/basculegion.png"
    },
    {
        "name": "Vulpix",
        "url": "/assets/shiny/vulpix.png"
    },
    {
        "name": "Ninetales",
        "url": "/assets/shiny/ninetales.png"
    },
    {
        "name": "Tentacool",
        "url": "/assets/shiny/tentacool.png"
    },
    {
        "name": "Tentacruel",
        "url": "/assets/shiny/tentacruel.png"
    },
    {
        "name": "Finneon",
        "url": "/assets/shiny/finneon.png"
    },
    {
        "name": "Lumineon",
        "url": "/assets/shiny/lumineon.png"
    },
    {
        "name": "Magby",
        "url": "/assets/shiny/magby.png"
    },
    {
        "name": "Magmar",
        "url": "/assets/shiny/magmar.png"
    },
    {
        "name": "Magmortar",
        "url": "/assets/shiny/magmortar.png"
    },
    {
        "name": "Magnemite",
        "url": "/assets/shiny/magnemite.png"
    },
    {
        "name": "Magneton",
        "url": "/assets/shiny/magneton.png"
    },
    {
        "name": "Magnezone",
        "url": "/assets/shiny/magnezone.png"
    },
    {
        "name": "Bronzor",
        "url": "/assets/shiny/bronzor.png"
    },
    {
        "name": "Bronzong",
        "url": "/assets/shiny/bronzong.png"
    },
    {
        "name": "Elekid",
        "url": "/assets/shiny/elekid.png"
    },
    {
        "name": "Electabuzz",
        "url": "/assets/shiny/electabuzz.png"
    },
    {
        "name": "Electivire",
        "url": "/assets/shiny/electivire.png"
    },
    {
        "name": "Gligar",
        "url": "/assets/shiny/gligar.png"
    },
    {
        "name": "Gliscor",
        "url": "/assets/shiny/gliscor.png"
    },
    {
        "name": "Gible",
        "url": "/assets/shiny/gible.png"
    },
    {
        "name": "Gabite",
        "url": "/assets/shiny/gabite.png"
    },
    {
        "name": "Garchomp",
        "url": "/assets/shiny/garchomp.png"
    },
    {
        "name": "Nosepass",
        "url": "/assets/shiny/nosepass.png"
    },
    {
        "name": "Probopass",
        "url": "/assets/shiny/probopass.png"
    },
    {
        "name": "Voltorb",
        "url": "/assets/shiny/voltorb-hisuian.png"
    },
    {
        "name": "Electrode",
        "url": "/assets/shiny/electrode-hisuian.png"
    },
    {
        "name": "Rotom",
        "url": "/assets/shiny/rotom.png"
    },
    {
        "name": "Chingling",
        "url": "/assets/shiny/chingling.png"
    },
    {
        "name": "Chimecho",
        "url": "/assets/shiny/chimecho.png"
    },
    {
        "name": "Misdreavus",
        "url": "/assets/shiny/misdreavus.png"
    },
    {
        "name": "Mismagius",
        "url": "/assets/shiny/mismagius.png"
    },
    {
        "name": "Cleffa",
        "url": "/assets/shiny/cleffa.png"
    },
    {
        "name": "Clefairy",
        "url": "/assets/shiny/clefairy.png"
    },
    {
        "name": "Clefable",
        "url": "/assets/shiny/clefable.png"
    },
    {
        "name": "Sneasel",
        "url": "/assets/shiny/sneasel-hisuian.png"
    },
    {
        "name": "Sneasler",
        "url": "/assets/shiny/sneasler.png"
    },
    {
        "name": "Weavile",
        "url": "/assets/shiny/weavile.png"
    },
    {
        "name": "Snorunt",
        "url": "/assets/shiny/snorunt.png"
    },
    {
        "name": "Glalie",
        "url": "/assets/shiny/glalie.png"
    },
    {
        "name": "Froslass",
        "url": "/assets/shiny/froslass.png"
    },
    {
        "name": "Cranidos",
        "url": "/assets/shiny/cranidos.png"
    },
    {
        "name": "Rampardos",
        "url": "/assets/shiny/rampardos.png"
    },
    {
        "name": "Shieldon",
        "url": "/assets/shiny/shieldon.png"
    },
    {
        "name": "Bastiodon",
        "url": "/assets/shiny/bastiodon.png"
    },
    {
        "name": "Swinub",
        "url": "/assets/shiny/swinub.png"
    },
    {
        "name": "Piloswine",
        "url": "/assets/shiny/piloswine.png"
    },
    {
        "name": "Mamoswine",
        "url": "/assets/shiny/mamoswine.png"
    },
    {
        "name": "Bergmite",
        "url": "/assets/shiny/bergmite.png"
    },
    {
        "name": "Avalugg",
        "url": "/assets/shiny/avalugg-hisuian.png"
    },
    {
        "name": "Snover",
        "url": "/assets/shiny/snover.png"
    },
    {
        "name": "Abomasnow",
        "url": "/assets/shiny/abomasnow.png"
    },
    {
        "name": "Zorua",
        "url": "/assets/shiny/zorua-hisuian.png"
    },
    {
        "name": "Zoroark",
        "url": "/assets/shiny/zoroark-hisuian.png"
    },
    {
        "name": "Rufflet",
        "url": "/assets/shiny/rufflet.png"
    },
    {
        "name": "Braviary",
        "url": "/assets/shiny/braviary-hisuian.png"
    },
    {
        "name": "Riolu",
        "url": "/assets/shiny/riolu.png"
    },
    {
        "name": "Lucario",
        "url": "/assets/shiny/lucario.png"
    }
]
export default pokemon